import { BeforeYouBuyThirdPartyDisclaimer } from './BeforeYouBuyThirdPartyDisclaimer';
import { BeforeYouBuyDataCollectionDisclaimer } from './BeforeYouBuyDataCollectionDisclaimer';
import type { FunctionComponent } from 'react';

import styled from 'styled-components';

const BeforeYouBuyThirdPartyModalDisclaimersContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BeforeYouBuyThirdPartyModalDisclaimers: FunctionComponent = () => {
  return (
    <BeforeYouBuyThirdPartyModalDisclaimersContainer>
      <BeforeYouBuyDataCollectionDisclaimer />
      <BeforeYouBuyThirdPartyDisclaimer />
    </BeforeYouBuyThirdPartyModalDisclaimersContainer>
  );
};
